export default {
    name: 'agroevents-reports',
    serverName: '/api/v1/agrotechnical_events/',
    eventsFieldApi: '/api/v1/agrotechnical_events/field_events/',
    eventsAccountingApi: '/api/v1/agrotechnical_events/field_event/',
    vegetationApi: '/api/v1/field_forecast/vegetation_phase/',
    agroEventsApi: '/api/v1/agrotechnical_events/event/'
};
